const colourVariants = {
  h2: {
    plum: 'text-plum-700',
    blue: 'text-blue-700',
    orange: 'text-orange-700',
    moon: 'text-moon-700',
  },
  text500: {
    plum: 'text-plum-500',
    blue: 'text-blue-500',
    orange: 'text-orange-500',
    moon: 'text-moon-500',
  },
  text700: {
		plum: 'text-plum-700',
		blue: 'text-blue-700',
		orange: 'text-orange-700',
		moon: 'text-moon-700',
	},
  text900: {
    plum: 'text-plum-900',
    blue: 'text-blue-900',
    orange: 'text-orange-900',
    moon: 'text-moon-900',
  },
  fill300: {
      plum: 'bg-plum-300',
      blue: 'bg-blue-300',
      orange: 'bg-orange-300',
      moon: 'bg-moon-300',
  },
  fill500: {
    plum: 'fill-plum-500',
    blue: 'fill-blue-500',
    orange: 'fill-orange-500',
    moon: 'fill-moon-500',
  },
  fill700: {
    plum: 'fill-plum-700',
    blue: 'fill-blue-700',
    orange: 'fill-orange-700',
    moon: 'fill-moon-700',
  },
  fill900: {
    plum: 'fill-plum-900',
    blue: 'fill-blue-900',
    orange: 'fill-orange-900',
    moon: 'fill-moon-900',
  },
  border100: {
    plum: 'border-plum-100',
    blue: 'border-blue-100',
    orange: 'border-orange-100',
    moon: 'border-moon-100',
  },
  border700: {
    plum: 'border-plum-700',
    blue: 'border-blue-700',
    orange: 'border-orange-700',
    moon: 'border-moon-700',
  },
  bg100: {
		plum: 'bg-plum-100',
		blue: 'bg-blue-100',
		orange: 'bg-orange-100',
		moon: 'bg-moon-100',
	},
  "odd:bg100": {
    plum: 'odd:bg-plum-100',
    blue: 'odd:bg-blue-100',
    orange: 'odd:bg-orange-100',
    moon: 'odd:bg-moon-100',
  },
  bg700: {
    plum: 'bg-plum-700',
    blue: 'bg-blue-700',
    orange: 'bg-orange-700',
    moon: 'bg-moon-700',
  },
  "hover:bg700": {
    plum: 'hover:bg-plum-700',
    blue: 'hover:bg-blue-700',
    orange: 'hover:bg-orange-700',
    moon: 'hover:bg-moon-700',
  },
  "hover:bg900": {
    plum: 'hover:bg-plum-900',
    blue: 'hover:bg-blue-900',
    orange: 'hover:bg-orange-900',
    moon: 'hover:bg-moon-900',
  },
  stroke500: {
		plum: 'stroke-plum-500',
		blue: 'stroke-blue-500',
		orange: 'stroke-orange-500',
		moon: 'stroke-moon-500',
	},
  stroke700: {
      plum: 'stroke-plum-700',
      blue: 'stroke-blue-700',
      orange: 'stroke-orange-700',
      moon: 'stroke-moon-700',
  },
  divide900: {
    plum: 'divide-plum-900',
    blue: 'divide-blue-900',
    orange: 'divide-orange-900',
    moon: 'divide-moon-900',
  },
  mpText : {
    plum: 'main-page-text-plum',
    blue: 'main-page-text-blue',
    orange: 'main-page-text-orange',
    moon: 'main-page-text-moon',
  },
  "focus:ring700" : {
    plum: 'focus:ring-plum-700',
    blue: 'focus:ring-blue-700',
    orange: 'focus:ring-orange-700',
    moon: 'focus:ring-moon-700',
  },
}

export {
  colourVariants
}